import React, { useState, useEffect } from 'react';
import { useApp } from '../context/AppContext';
import Header from './Header';
import MainDisplay from './MainDisplay';
import HistoryPanel from './HistoryPanel';
import VariablesPanel from './VariablesPanel';
import ChatSidebar from './ChatSidebar';
import ButtonPad from './ButtonPad';
import WelcomeScreen from './WelcomeScreen';
import OnboardingScreen from './OnboardingScreen';
import ApprovalPanel from './ApprovalPanel';

const Layout: React.FC = () => {
  const { state } = useApp();
  const [showOnboarding, setShowOnboarding] = useState(false);

  // Check if user is new (first time visiting)
  useEffect(() => {
    const hasSeenOnboarding = localStorage.getItem('decalculator-onboarding-seen');
    if (!hasSeenOnboarding && state.currentUser.id) {
      setShowOnboarding(true);
    }
  }, [state.currentUser.id]);

  const handleOnboardingComplete = () => {
    localStorage.setItem('decalculator-onboarding-seen', 'true');
    setShowOnboarding(false);
  };

  // Show welcome screen if user hasn't set up their profile
  if (!state.currentUser.id) {
    return <WelcomeScreen />;
  }

  // Show onboarding screen for new users
  if (showOnboarding) {
    return <OnboardingScreen onComplete={handleOnboardingComplete} />;
  }

  return (
    <div className="h-screen bg-dark-900 text-white flex flex-col overflow-hidden">
      <Header />
      
      <div className="flex-1 flex flex-col lg:flex-row min-h-0">
        {/* Variables Section - Top on mobile/tablet, Left on desktop */}
        <div className="w-full lg:w-56 xl:w-64 flex-shrink-0 border-b lg:border-b-0 lg:border-r border-dark-700 bg-dark-800/30">
          <VariablesPanel />
        </div>
        
        {/* Main Calculator Area */}
        <div className="flex-1 flex flex-col lg:flex-row min-h-0">
          {/* Left Panel - Calculator */}
          <div className="flex-1 flex flex-col p-1 sm:p-2 space-y-1 sm:space-y-2 min-w-0 min-h-0">
            {/* Calculator Display */}
            <div className="flex-shrink-0">
              <MainDisplay />
            </div>
            
            {/* Button Pad - Takes most space */}
            <div className="flex-1 min-h-0">
              <ButtonPad />
            </div>
          </div>
          
          {/* Right Panel - History, Approvals, and Chat */}
          <div className="w-full lg:w-72 xl:w-80 flex flex-col space-y-1 sm:space-y-2 p-1 sm:p-2 border-t lg:border-t-0 lg:border-l border-dark-700 bg-dark-800/50 min-h-0">
            <div className="flex-1 min-h-0" style={{ flex: state.isMultiplayerMode ? '1.2' : '1' }}>
              <HistoryPanel />
            </div>
            
            {/* Approval Panel - Only show for session creators when approval is required */}
            {state.isMultiplayerMode && state.currentSession?.settings.requireApproval && (
              <div className="flex-shrink-0">
                <ApprovalPanel />
              </div>
            )}
            
            {state.isMultiplayerMode && state.currentSession && (
              <div className="flex-shrink-0" style={{ flex: '0.8' }}>
                <ChatSidebar />
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Layout;
